import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleChange } from "../../../pages/generalReducer/action/GlobalAction";

const GalleryReusableHook = () => {
  const dispatch = useDispatch();
  const lightbox_status = useSelector(
    (state) => state.GlobalReducer.lightbox_status
  );

  const [opent, setOpen] = useState(false);

  const openLightbox = (status) => {
    dispatch(handleChange({ lightbox_status: status }));
  };
  const closeLightbox = () => {
    dispatch(handleChange({ lightbox_status: false }));
  };
  return {
    openLightbox,
    closeLightbox,
  };
};

export default GalleryReusableHook;
